export default __webpack_public_path__ + "static/object-tile-size-dark-30c8170ac774051036a86213893a6ab1d1a20e2031b752ab82444a73455b7762.png";